/* eslint-disable */
import React from "react";
import { withRouter } from "react-router-dom";
import "./HundredmsVc.css";
import { HUNDRED_MSCALL, } from "../../../utils/constant";

class HundredmsVc extends React.Component {
    state = {
        vc_call_code: ""
    }

    constructor(props) {
        super(props);
    }

    componentDidMount() {
    }

    // cancelVccall() {
    //     this.setState({
    //         vc_call_code: "11234564567854567%*$(##($#)@#($%$(#)@(#$%*$#(@#$*%$(#@#*$#(35676545678765"
    //     }, () => {
    //         this.setState({
    //             vc_call_code: ""
    //         }, () => {
    //             this.props.callEnded();
    //         })
    //     })
    // }

    render() {
        return (
            <React.Fragment>
                {this.props.vcInfo.doctor_room_code ? <>
                    <div className="hundredms-overlay">
                        {/* <div className='hundredms-header'>
                            VC Conferencing
                            <button className='btn btn-primary btn-sm pull-right'
                                onClick={() => this.cancelVccall()}
                            >Close</button>
                        </div> */}
                        <div className='hundredms-body'>
                            <iframe
                                title="100ms-app"
                                allow="camera *;microphone *;display-capture *"
                                // src={`${HUNDRED_MSCALL}${this.state.vc_call_code ? this.state.vc_call_code : this.props.vcInfo.doctor_room_code}`}
                                src={`${HUNDRED_MSCALL}${this.props.vcInfo.doctor_room_code}`}
                                style={{ height: "100vh", width: "100%", border: "0" }}
                            >
                            </iframe>
                        </div>
                    </div>
                </> : null}
            </React.Fragment>
        );
    }
}

export default withRouter(HundredmsVc);